import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CSGOArrayModel, CSGOModel } from "../../models/CSGOModel";

const initialCSGOState: CSGOArrayModel = {
  all_CSGOs: [],
  particular_CSGO: {
    csgoid: 0,
    name: "",
    csgouserId: 0,
    description: "",
    isActive: false,
  },
  isCsgoFetching: false,
};
const CSGOSlice = createSlice({
  name: "CSGO",
  initialState: initialCSGOState,
  reducers: {
    setCSGOs(state, action: PayloadAction<CSGOModel[]>) {
      state.all_CSGOs = action.payload;
    },
    setParticularCSGO(state, action: PayloadAction<CSGOModel>) {
      state.particular_CSGO = action.payload;
    },
    setIsCsgoFetching(state, action: PayloadAction<boolean>) {
      state.isCsgoFetching = action.payload;
    },
  },
});
export default CSGOSlice;
